<template>
  <div class="wrap-bg wrap-data-manage wrap-content-list pd15">
    <v-breadcrumb :breadcrumb-list="breadcrumbList" />
    <div class="bg-white pd-btm15 f-pr breadcrumb-btm-con-box">
      <h3 class="f-fs16 f-fwn bor-btm-gray pd15">{{ paramObj.pageType === 'edit' ? '修改用户' : '新增用户'}}</h3>
      <div
        v-loading="isLoading"
        :element-loading-text="loadTxt"
        element-loading-spinner="el-icon-loading"
        class="list-filter-wrap-box">
        <v-list-filter
          v-model="bindForms"
          :form-arr="formArr"
          :form-rules="formRules"
          :is-add-btn="false"
          :is-group-btn="true"
          :isLoading="isLoading"
          :page-type="paramObj.pageType"
          form-item-position="vertical"
          class="list-filter bg-white"
          @changeFormBind="changeFormBind"
          @filterCheckBtn="saveBtn"
          @filterResetBtn="cancleBtn"/>
      </div>
    </div>
  </div>
</template>

<script>
import vBreadcrumb from '@/components/breadcrumb.vue'
import pageConfig from './page.config.js'
import vListFilter from '@/components/form-filter/index.vue'
import $filterCommon from '@/components/form-filter/index.js'
import {
  getDetailInfo,
  checkAccount,
  addUser,
  updateUser
} from '@/api/backManage/userManage.js'
export default {
  components: {
    vBreadcrumb,
    vListFilter
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: '后台管理'
        },
        {
          name: '用户管理',
          path: '/back/userManage'
        },
        {
          name: '修改用户'
        }
      ],
      isLoading: false,
      loadTxt: '加载中',
      userInfo: {},
      paramObj: {},
      bindForms: {},
      formArr: [],
      formRules: {}
    }
  },
  mounted() {
    // 获取参数
    this.paramObj = this.$route.query
    // 表单规则
    this.formRules = JSON.parse(JSON.stringify(pageConfig.formRules))
    // 账号检查
    const checkAccountRule = async(rule, value, callback) => {
      const res = await this.checkAccount(value)
      // 只要res.data === false,则账号不存在；或者当前是编辑页面，账号不改变
      if ((!res.data && res.status * 1 === 200) || (this.paramObj.pageType === 'edit' && value === this.userInfo.account)) {
        callback()
      } else {
        // 不合法
        callback(new Error('账号已存在'))
      }
    }
    this.formRules.account.push({ validator: checkAccountRule, trigger: 'blur' })
    // 页面初始化
    this.formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
    if (this.paramObj.pageType === 'edit') {
      // 开始请求详情
      this.getDetailInfo(this.paramObj, data => {
        this.init(data)
      })
    } else {
      this.breadcrumbList[this.breadcrumbList.length - 1].name = '新增用户'
      this.init()
    }
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        // 表单
        const formArr = this.formArr.filter(item => !item.modelHide || this.paramObj.pageType === 'add')
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        this.bindForms = filterObj.filterChooseObj
        this.formArr = filterObj.filterList
      })
    },
    // 获取详情信息
    getDetailInfo(paramObj, cb) {
      this.isLoading = true
      this.loadTxt = '加载中'
      getDetailInfo({
        id: paramObj.id
      }).then(res => {
        this.isLoading = false
        const data = res.data || {}
        this.userInfo = data
        // 表单初始化值
        this.formArr.forEach(item => {
          item.intValue = data[item.id] || ''
        })
        // 回调
        cb && cb(data)
      })
    },
    // 检查账号
    checkAccount(value) {
      return new Promise(resolve => {
        checkAccount({
          account: value || this.bindForms.account
        }).then(res => {
          resolve(res)
        })
      })
    },
    // 绑定表单
    changeFormBind(bindForms, item, value) {
      this.bindForms = bindForms
    },
    // 确定保存
    saveBtn() {
      this.isLoading = true
      this.loadTxt = '保存中'
      if (this.paramObj.pageType === 'edit') {
        // 用户更新
        updateUser(Object.assign(this.bindForms, {
          id: this.paramObj.id
        })).then(res => {
          this.saveHandle(res)
        })
      } else {
        // 新增用户
        addUser(this.bindForms).then(res => {
          this.saveHandle(res)
        })
      }
    },
    // 保存后处理
    saveHandle(res) {
      this.isLoading = false
      if (res.data && res.status * 1 === 200) {
        this.$message({
          type: 'success',
          message: '保存成功！'
        })
        this.cancleBtn()
        // 同步更新列表
        this.$bus.$emit('updateUser')
      } else {
        this.$message({
          type: 'error',
          message: res.message || '保存失败！'
        })
      }
    },
    // 取消
    cancleBtn() {
      this.$router.push({
        path: '/back/userManage'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.list-filter-wrap-box{
  padding-left: 50px;
  min-height: 600px;
}
/deep/.list-filter-wrap-box .el-select{
  width: 100%;
}
</style>
